import React from 'react';
import { Grid } from '@material-ui/core';
import Button from 'catalyst/core/Button';
import { useDispatch } from 'react-redux';
import { logMeIn } from 'redux/actions/authActions';
import { useHistory } from 'react-router-dom';

const QlikSaasSingleSignOn = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    return (
        <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
        >
            <Grid item>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => dispatch(logMeIn(history))}
                >
                    Log in with Qlik SaaS
                </Button>
            </Grid>
        </Grid>
    );
};

export default QlikSaasSingleSignOn;
